module.exports = __webpack_public_path__ + "img/img54.fb261dc1.svg";